<script lang="ts">

  import { createEventDispatcher } from 'svelte';
  import type { SmartmodelMessage } from './types/smartmodel-message';
  import { sendMessageWritable } from '../stores/iframe-communication.store';

  let iframe: HTMLIFrameElement;
  export let appUrl = 'http://localhost:4200';

  const dispatch = createEventDispatcher<{ iframeMessage: SmartmodelMessage }>();

  const handleIframeMessage = (msg: MessageEvent<SmartmodelMessage>) => {
    if (msg.data.receiver && msg.data.data) {
      dispatch('iframeMessage', msg.data);
    }
  }

  sendMessageWritable.subscribe(message => {
    console.log(message);
    if (message) {
      iframe.contentWindow.postMessage({...message, debug: true}, appUrl)
    }
  })

</script>

<svelte:window on:message={handleIframeMessage}/>

<div class="aspect-ratio-wrapper">
  <iframe src={appUrl} bind:this={iframe}
          width="100%"
          height="100%"
          title="SmartModel Iframe">
  </iframe>
</div>

<style lang="scss">
  .aspect-ratio-wrapper {
    max-height: 80vh;
    aspect-ratio: 16 / 8.99;
    max-width: 100vw;
    margin: auto;
  }

  @media (max-width: 800px) {
    .aspect-ratio-wrapper {
      max-height: 100vh;
    }
  }

  iframe {
    width: 100%;
    height: 100%;
  }
</style>
